export const DEFAULT_CHILD_RATE_FACTOR = 0.5;

export const AMOUNT_OVERRIDE_REASON = {
  DISCOUNT: 'discount',
  SPECIAL_PACKAGE: 'special_package',
  INFLUENCER: 'influencer',
  SPECIAL_GUEST: 'special_guest',
  CORRECTION: 'correction',
  OTHER: 'other',
} as const;

export const AMOUNT_OVERRIDE_REASON_LABEL: Record<string, string> = {
  [AMOUNT_OVERRIDE_REASON.DISCOUNT]: 'Discount',
  [AMOUNT_OVERRIDE_REASON.SPECIAL_PACKAGE]: 'Special package',
  [AMOUNT_OVERRIDE_REASON.INFLUENCER]: 'Influencer',
  [AMOUNT_OVERRIDE_REASON.SPECIAL_GUEST]: 'Special guest',
  [AMOUNT_OVERRIDE_REASON.CORRECTION]: 'Correction',
  [AMOUNT_OVERRIDE_REASON.OTHER]: 'Other',
};

export const AMOUNT_OVERRIDE_REASON_OPTIONS = Object.values(AMOUNT_OVERRIDE_REASON);

export function getChildRateFactor(): number {
  const raw = process.env.REACT_APP_CHILD_RATE_FACTOR;
  const parsed = raw === undefined ? DEFAULT_CHILD_RATE_FACTOR : Number(raw);
  return Number.isFinite(parsed) && parsed >= 0 && parsed <= 1
    ? parsed
    : DEFAULT_CHILD_RATE_FACTOR;
}
